import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-5 2.66a1 1 0 0 0 -1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0 -1 -1","key":"svg-0"}]]

const IconClockHour12Filled = createReactComponent('filled', 'clock-hour-12-filled', 'ClockHour12Filled', __iconNode);

export default IconClockHour12Filled;